export default {
  mutations: {
    setWindowWidth (state) {
      state.windowWidth = window.innerWidth
    },
    setWindowHeight (state) {
      state.windowHeight = window.innerHeight
    }
  },
  getters: {
    getWindowWidth (state) {
      return state.windowWidth
    },
    getWindowHeight (state) {
      return state.windowHeight
    },
    isLarge (state) {
      return state.windowWidth > 768
    },
    isSmall (state) {
      return state.windowWidth <= 768
    },
    isVertical (state) {
      return state.windowHeight > state.windowWidth
    }
  },
  state: {
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/screen.js